export default __webpack_public_path__ + "static/media/five.c8e1cdec.svg";